import { addHours, differenceInMinutes, isAfter } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import dayjs from 'dayjs';

import { IViewStandbyPeriod, IStandbyPeriod, ICreateStandbyPeriod } from '../../../../domain/standby-period/interface';
import { IResource } from '../../../../domain/event/resource';
import { toUniversalTime } from '../../../../domain/event';

export const isCompleted = (standbyPeriod: IStandbyPeriod) => {
    if (!standbyPeriod.id) return false;

    return isAfter(new Date(), new Date(standbyPeriod.datetime_end));
};
export const isStarted = (standbyPeriod: IStandbyPeriod) => {
    return isAfter(new Date(), new Date(standbyPeriod.datetime_start));
};

export const toViewStandbyPeriod = (standbyPeriod: Partial<IStandbyPeriod>): IViewStandbyPeriod => {
    const viewStandbyPeriod: IViewStandbyPeriod = {
        duration_hours: 24, // 24h
        program_id: standbyPeriod.source?.program?.id || undefined,
    };

    if (standbyPeriod.datetime_start) {
        const zoneDate = toZonedTime(standbyPeriod.datetime_start, standbyPeriod.site!.site_timezone);
        viewStandbyPeriod.datetime_start_local = dayjs(zoneDate) || undefined;
    }

    if (standbyPeriod.datetime_start && standbyPeriod.datetime_end) {
        const diffInMinutes = differenceInMinutes(standbyPeriod.datetime_end, standbyPeriod.datetime_start);
        viewStandbyPeriod.duration_hours = Math.round((diffInMinutes / 60) * 100) / 100;
    }

    return viewStandbyPeriod;
};

export const toBatchRequest = (standbyPeriod: IViewStandbyPeriod, resources?: IResource[]) => {
    return {
        ...(resources ? { sites: resources.map(r => +r.id) } : { sites: [] }),
        standbyPeriod: {
            datetime_start_local: toUniversalTime(standbyPeriod.datetime_start_local),
            datetime_end_local: toUniversalTime(addHours(standbyPeriod.datetime_start_local, standbyPeriod.duration_hours))!,
            program_id: standbyPeriod.program_id,
        } as ICreateStandbyPeriod,
    };
};
